export default __webpack_public_path__ + "776b483724347b06c53025affcc71336.svg";